import React, { useEffect } from "react";
import FindProduct from "../../../components/FindProduct/FindProduct";
import {withRouter} from "react-router-dom"
import { connect } from "react-redux";
import AdminNavbar from "../../../components/Admin/adminNavbar";
import AuthAdmin from "../../../components/AuthAdmin/AuthAdmin";
import EditProductComponent from "../../../components/EditProductComponent/EditProductComponent";
import Spinner from "../../../components/Spinner/Spinner";

const EditProduct = props=>{

   
    let {isAuthenticated,admin,staff,userId} = props;
    if(localStorage.getItem("idToken")){
      if(userId == null && admin == null && staff==null){
        return <Spinner/>
      }
    }

    if(!isAuthenticated || !(admin||staff)){
        return <AuthAdmin/> 
      }

    let {productId} = props.match.params;
    return(
        <>
         <AdminNavbar />
        { 
            productId?<EditProductComponent productId={productId}/> : <FindProduct/>
        }
           
            
        </>
    )
}

const mapStateToProps = (state) => {
    return {
      isAuthenticated:state.auth.userId!=null,
      admin:state.auth.admin,
      staff:state.auth.staff,
      userId:state.auth.userId
    };
  };

export default  connect(mapStateToProps,null) (withRouter (EditProduct))